export const GoalLevels = {
  less: "less",
  lessOrEqual: "lessOrEqual",
  greater: "greater",
  greaterOrEqual: "greaterOrEqual",
  equal: "equal",
};
